import React from 'react';
import * as Sentry from "@sentry/react";

/**
 * Error boundary component that uses Sentry to catch and report rendering errors
 * Provides a fallback UI when errors occur
 */
const SentryErrorBoundary = ({ children }) => (
  <Sentry.ErrorBoundary fallback={
    <div className="error-container" style={{
      padding: '20px',
      margin: '20px',
      backgroundColor: '#fff8f8',
      border: '1px solid #ffcdcd',
      borderRadius: '8px',
      textAlign: 'center'
    }}>
      <h2>Something went wrong</h2>
      <p>We've been notified about the problem and will fix it as soon as possible.</p>
      <button 
        onClick={() => window.location.reload()}
        style={{
          backgroundColor: '#3b82f6',
          color: 'white',
          border: 'none',
          padding: '10px 16px',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '14px'
        }}
      >
        Try again
      </button>
    </div>
  }>
    {children}
  </Sentry.ErrorBoundary>
);

export default SentryErrorBoundary; 